import {
  HoveredEvents,
  PAEventType
} from '@dadohr/shared/domainTypes/productAnalytics';
import { useProductAnalytics } from '../services/productAnalytics';
import { useTrackDuration } from './useTrackDuration';

export const useHoverDurationTracking = ({
  name,
  explanation
}: {
  name: HoveredEvents;
  explanation: string;
}) => {
  const { trackEvent } = useProductAnalytics();
  const { startTimer, getDuration } = useTrackDuration();

  const onMouseEnter = () => {
    startTimer();
  };

  const onMouseLeave = () => {
    if (getDuration() < 1000) return; //don't track if hovering is less than a second
    trackEvent({
      eventType: PAEventType.OTHER,
      name: name,
      Explanation: explanation,
      Duration: Math.round(getDuration() / 1000)
    });
  };

  return {
    onMouseEnter,
    onMouseLeave
  };
};
